import React from 'react'
import { string, number, bool, func, shape, oneOfType } from 'prop-types'

import FormControlWithFloatingLabel from 'views/components/molecules/FormControlWithFloatingLabel'

import './InputTextWithFloatingLabel.scss'

const InputTextWithFloatingLabel = props => {
  const id = props.id ? props.id : props.name

  return <FormControlWithFloatingLabel {...props} id={id} formControl="input" />
}

InputTextWithFloatingLabel.propTypes = {
  label: string,
  value: string,
  watch: string,
  defaultValue: string,
  name: string.isRequired,
  id: string,
  disabled: bool,
  inputType: string,
  highlight: bool,
  errorMessage: string,
  disableAutoCompleteAndFriends: bool,
  onBlur: func,
  onKeyUp: func,
  onClear: func,
  onChange: func,
  required: bool,
  placeholder: string,
  register: func,
  errors: shape({}),
  useExternalValidator: bool,
  adyenField: string,
  minLength: oneOfType([string, number]),
  maxLength: oneOfType([string, number]),
  isDeclarative: bool,
  isNotEqualTo: shape({
    fieldId: string.isRequired,
    errorMessage: string.isRequired
  })
}

InputTextWithFloatingLabel.defaultProps = {
  label: '',
  value: undefined,
  watch: null,
  defaultValue: null,
  disabled: null,
  inputType: 'text',
  highlight: null,
  errorMessage: null,
  id: null,
  disableAutoCompleteAndFriends: false,
  onBlur: null,
  onKeyUp: null,
  onClear: null,
  onChange: null,
  required: null,
  placeholder: null,
  register: null,
  errors: null,
  useExternalValidator: false,
  adyenField: null,
  minLength: undefined,
  maxLength: undefined,
  isDeclarative: false,
  isNotEqualTo: undefined
}

export default InputTextWithFloatingLabel
